var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button"},[_c('div',{on:{"click":function($event){$event.stopPropagation();return _vm.signUp(_vm.item)}}},[_c('img',{attrs:{"src":require("@/assets/hideBox/baoming.png"),"alt":""}}),_c('span',[_vm._v("立即报名")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }